import axios from 'axios';
import {isProduction} from '../index';

export var BaseUrl;


/*** "proxy": "http://37.156.21.142:5050/api" ***/
export async function ajax(sys, url, Method, isbody, body) {

    BaseUrl=process.env.REACT_APP_API_URL;
    let localUrl = BaseUrl + url;
    // let localUrl = url;
    var token =  localStorage.getItem('accessToken');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' +  token;
    switch (sys) {
        case 'tokenFormData':
            return await axios({
                method: Method,
                url: localUrl,
                data: isbody ? body : null,
                headers: { 'Content-Type': 'multipart/form-data' }
            });

        case 'tokenJson':
            return (
                 await axios({
                     url:localUrl,
                     method:Method,
                     data:  isbody ? JSON.stringify(body) : null,
                     timeout: 60 * 3 * 1000, // Let's say you want to wait at least 3 mins

                     headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                     },

                })
            );
        case 'excelDownload':
            return (
                await axios({
                    url: localUrl,
                    method: Method,
                    data: isbody ? JSON.stringify(body) : null,
                    headers: {
                        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    },
                    responseType: 'arraybuffer',
                })
            );

        case 'TokenUrl':
            return await axios({
                url: localUrl + body,
                method: Method,
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + token
                }
              });
        case 'Url':
            function checkbody(localUrl,body){
                if(typeof(body) === 'undefined'){
                    return localUrl
                }else{
                    return localUrl + body
                }
            }
            return await axios({
                url:        checkbody(localUrl,body),
                method:     Method,
                headers: {
                  Accept:           'application/json',
                  'Content-Type':   'application/json',
                }
              });
        case 'FormData':
            return await axios({
                method: Method,
                url: localUrl,
                data: isbody ? body : null,
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        default:
            return (
                await axios({
                    url: localUrl ,
                    method: Method,
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    data: isbody ? JSON.stringify(body) : null
                })
            )
    }
}

